import { c as _c } from "react/compiler-runtime";
import { TrustBar } from "@/sanity/sanity.types";
import css from "./home-trust.module.scss";
import GridRow from "@/components/common/grid-row/grid-row";
import GridColumn from "@/components/common/grid-column/grid-column";
import imageUrl from "@/sanity/utilities/imageUrl";
import Image from "@/components/common/image/image";
import Marquee from "@/components/common/marquee/marquee";
import { CSSProperties } from "react";
interface IHomeTrustProps {
  data: TrustBar;
  className?: string;
  style?: CSSProperties;
}
const HomeTrust = props => {
  const $ = _c(13);
  const {
    data,
    className,
    style
  } = props;
  if (!data?.badges || data.badges.length === 0) {
    return null;
  }
  const t0 = `${css.homeTrust} ${className} !max-w-[1440px] rounded-b-xl`;
  let t1;
  if ($[0] !== data.badges) {
    t1 = data.badges?.map(_temp);
    $[0] = data.badges;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <Marquee className="lg:!hidden" items={t1} />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== data.badges) {
    t3 = data.badges?.map(_temp2);
    $[4] = data.badges;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <GridRow className="!hidden lg:!grid"><GridColumn><Marquee items={t3} /></GridColumn></GridRow>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== style || $[9] !== t0 || $[10] !== t2 || $[11] !== t4) {
    t5 = <div className={t0} style={style}>{t2}{t4}</div>;
    $[8] = style;
    $[9] = t0;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export default HomeTrust;
function _temp(badge, index) {
  if (!badge.image?.asset) {
    return null;
  }
  return <Image key={index} src={imageUrl(badge.image?.asset).height(32).url()} height={32} alt={badge.label ?? ""} className="h-8 w-full object-contain" />;
}
function _temp2(badge_0, index_0) {
  if (!badge_0.image?.asset) {
    return null;
  }
  return <Image key={index_0} src={imageUrl(badge_0.image?.asset).height(51).url()} alt={badge_0.label ?? ""} height={51} className="h-[51px] w-auto object-contain" />;
}